(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iam-idp/assets/javascripts/react/jotai/iam-idp-atoms.js') >= 0) return;  svs.modules.push('/modules/iam-idp/assets/javascripts/react/jotai/iam-idp-atoms.js');
"use strict";



const _jotai = jotai,
  atom = _jotai.atom,
  getDefaultStore = _jotai.getDefaultStore;
const loginType = svs.iam_idp.data.loginType;
const deviceIsBankId = loginType === 'BANKID';
const isPollingAtom = atom(false);
const qrCodeAtom = atom(false);
const activeMethodAtom = atom(deviceIsBankId ? svs.iam_idp.constants.loginMethods.bankid : svs.iam_idp.constants.loginMethods.freja);
const isNewCustomerAtom = atom(false);
const showLoaderAtom = atom(false);
const showFallbackAtom = atom(false);
const showFallbackQrAtom = atom(false);
const loginCompletedAtom = atom(false);
const store = getDefaultStore();
store.set(isPollingAtom, false);
store.set(loginCompletedAtom, false);
const loginAtoms = {
  isPollingAtom,
  activeMethodAtom,
  qrCodeAtom,
  isNewCustomerAtom,
  showLoaderAtom,
  showFallbackAtom,
  showFallbackQrAtom,
  loginCompletedAtom
};
svs.iam_idp.atoms = loginAtoms;

 })(window);